<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    components: {
        DatePicker
    },
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                department_id: '',
                user_id: '',
                amount: '',
                date: '',
                file: '',
                description: '',
                _method: 'POST',
            },
            file: '',
            fileName: ''
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.user_id = '';
            this.form.amount = '';
            this.form.date = '';
            this.form.file = '';
            this.form.description = '';
            this.file = '';
            this.fileName = '';
            this.$modal.hide('addDepartamentUser');
        },
        catch_file(event) {
            this.form.file = event.target.files[0];
            this.fileName = event.target.files[0].name;
        },
        async saveBuildings() {
            try {
                const data_form = new FormData();
                data_form.append('id', this.form.id);
                data_form.append('department_id', this.form.department_id);
                data_form.append('user_id', this.form.user_id);
                data_form.append('amount', this.form.amount);

                if (this.form.date) {
                    let dt = this.moment(this.form.date).format("YYYY-MM-DD");
                    data_form.append('date', dt);
                }
                data_form.append('file', this.form.file);
                data_form.append('description', this.form.description);

                let _endpoint = '/tenant';
                // if (form.id != "") {
                //     _endpoint = `/departments/store/${form.id}`;
                // }

                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-departaments');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.catalogue.get_users_profile(7);
    },
    created() {
        Event.$on("event-show-addDepartamentUser", (departament, tenant) => {
            departament.id =
                this.form.department_id = departament.id;

            if (tenant) {
                this.form.id = tenant.id;
                this.form.user_id = tenant.user_id;
                this.form.amount = tenant.amount;
                this.form.description = tenant.description;

                if (tenant.date) {
                    let dt = this.moment(tenant.date).toDate();
                    this.form.date = dt;
                }

                if (tenant.file) {
                    this.file = tenant.file;
                }

            }
            this.$modal.show('addDepartamentUser');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    }
}
</script>
<template>
    <modal v-bind:click-to-close="false" name="addDepartamentUser" :width="'80%'" :scrollable="true" :maxHeight="300"
        :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Arrendatario</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4 mt-3">
                        <label>Usurio</label><br>
                        <select class="form-control" v-model="form.user_id">
                            <option :value="user.id" v-for="(user, user_index) in catalogue.users_profile"
                                :key="user_index">
                                {{ user.name }} {{ user.last_name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>
                    <div class="col-md-4 mt-3">
                        <label>Renta</label>
                        <money class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>
                    <div class="col-md-4 mt-3">
                        <label>Fecha inicio</label>
                        <date-picker v-model="form.date"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Descripción</label>
                        <textarea type="text" :disabled="!prop_edit" class="form-control"
                            v-model="form.description"></textarea>
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Archivo</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input type="file" class="custom-file-input" :class="file != '' ? 'pr-5' : ''" id="customFile"
                                ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>


                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>